import LineChart from './LineChart';
import { connect } from 'react-redux';
import DoughnutChart from './DoughnutChart';
import HelpGuide from '../../modules/help/HelpGuide';
import { formatPrice } from '../../internals/managers/PaymentManager';
import { getDaySales, getDayTimeDetails } from '../../internals/managers/ReportsManager';

const ServicesGrowthWidget = (props: any) => {
  const { dayOrders, selectedShop } = props;
  const currency = selectedShop?.currency;

  const labels = getDayTimeDetails(dayOrders);
  const sales = getDaySales(labels, dayOrders);
  const totalToday = sales.reduce((a: number, b: number) => a + b, 0);
  const peakSale = Math.max(...(sales.length ? sales : [0]));
  const peakHour = sales.length ? labels[sales.indexOf(peakSale)] : null;

  return (
    <div className="flex flex-col gap-4">
      {/* Line chart card */}
      <div className="bg-surface border border-borderc rounded-card shadow-card p-6">
        <div className="flex items-start justify-between mb-6 gap-4 flex-wrap">
          <div>
            <p className="nl-caps">Today</p>
            <h2 className="text-[17px] font-semibold text-text1 tracking-[-0.025em] mt-1">
              Sales by hour
            </h2>
          </div>
          <div className="flex gap-6 text-right">
            <div>
              <p className="nl-caps">Total</p>
              <p className="font-mono text-[15px] font-semibold text-text1 mt-0.5">
                {formatPrice(totalToday, currency)}
              </p>
            </div>
            <div>
              <p className="nl-caps">{peakHour ? `Peak · ${peakHour}` : 'Peak'}</p>
              <p className="font-mono text-[15px] font-semibold text-brand mt-0.5">
                {formatPrice(peakSale, currency)}
              </p>
            </div>
          </div>
        </div>
        <div className="h-[320px]">
          <LineChart />
        </div>
      </div>

      {/* Bottom row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-surface border border-borderc rounded-card shadow-card p-6">
          <p className="nl-caps">Orders</p>
          <h2 className="text-[17px] font-semibold text-text1 tracking-[-0.025em] mt-1 mb-4">
            Orders of the day
          </h2>
          <div className="h-[280px]">
            <DoughnutChart />
          </div>
        </div>
        <HelpGuide />
      </div>
    </div>
  );
};

export default connect(
  (state: any) => ({
    dayOrders: state.dashboard.get('dayOrders'),
    selectedShop: state.dashboard.get('selectedShop'),
  }),
  () => ({})
)(ServicesGrowthWidget);
